export function formatCharges(charges) {
    if (!charges) return 0;
    if (typeof charges === "number") return charges;
    if (typeof charges === "string") {
        const num = parseFloat(charges);
        return isNaN(num) ? charges : num;
    }
    if (Array.isArray(charges)) {
        return charges.reduce((acc, item) => acc + Number(item.amt || 0), 0);
    }
    if (typeof charges === "object") {
        return charges.amt || 0;
    }
    return 0;
}

export function formatDate(dateStr) {
    if (!dateStr) return "-";
    return String(dateStr).split(" ")[0];
}

export function capitalize(text) {
    if (!text) return "-";
    return String(text).charAt(0).toUpperCase() + String(text).slice(1);
}

export function getDurationLabel(billing_interval, billing_period) {
    if (!billing_interval || !billing_period) return "-";

    const interval = Number(billing_interval);
    const period = String(billing_period).toLowerCase();

    if (period === "month") {
        if (interval === 1) return "1 Month";
        if (interval === 2) return "2 Months";
        if (interval === 3) return "3 Months";
        if (interval === 6) return "6 Months";
        if (interval === 12) return "12 Months";
        return `${interval} Months`;
    }

    if (period === "year") {
        if (interval === 1) return "12 Months";
        return `${interval} Years`;
    }

    return `${interval} ${period}`;
}

export function formatAddress(addr) {
    if (!addr) return "-";

    const parts = [
        addr?.address_1,
        addr?.address_2,
        addr?.city,
        addr?.state,
        addr?.postcode,
        addr?.country,
    ].filter(Boolean);

    return parts.length ? parts.join(", ") : "-";
}

export function getMemberName(m) {
    const fullName = `${m?.first_name || ""} ${m?.last_name || ""}`.trim();
    return fullName || m?.name || "-";
}

export function decodeHtml(str = "") {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
}

export function stripHtml(html = "") {
    return String(html)
        .replace(/<[^>]*>/g, " ")   // remove tags
        .replace(/\s+/g, " ")      // extra spaces
        .trim();
}
